/* eslint-disable react/no-find-dom-node */

import ReactDOM from 'react-dom';

const targetIsDescendant = (event, context) => {
  const parent = ReactDOM.findDOMNode(context);
  let node = event.target;

  while (node !== null) {
    if (node === parent) return true;
    node = node.parentNode;
  }
  return false;
};

const getButtomOffsetOfElementOnPage = element => {
  const domElement = ReactDOM.findDOMNode(element);

  const boundedDomElement = domElement.getBoundingClientRect();
  const buttomOffset = `${boundedDomElement.top + domElement.offsetHeight}px`;

  return buttomOffset;
};

const getWindowWidth = () => {
  return window.innerWidth;
};

const DomUtils = {
  targetIsDescendant,
  getButtomOffsetOfElementOnPage,
  getWindowWidth
};

export default DomUtils;



// WEBPACK FOOTER //
// ./src/utils/domUtils.js